import type { IDealTag } from "@interfaces/tag.interface";
import { TagLabel } from "@ui/Content";

type Props = {
  item: IDealTag & {
    stage?: { color?: string };
  };
} & React.HTMLAttributes<HTMLElement>;

export const SuggestionDeal = ({ item, ...rest }: Props) => {
  return (
    <div {...rest} className="flex min-w-0 cursor-pointer items-center gap-2 p-2">
      <div
        className="m-1 h-3 w-3 flex-shrink-0 rounded-[4px]"
        style={{ background: item.stage_color || item?.stage?.color }}
      />
      <TagLabel>{item.title}</TagLabel>
    </div>
  );
};
